__turbopack_context__.v({
  "offerElement": "UzNKzq_offerElement",
  "root": "UzNKzq_root",
});
